export class ActivityErrors {
    public static readonly SHORT_DURATION = "La duración debe ser mayor que 0";
    public static readonly WRONG_NAME = "El nombre de la activdad debe estar entre 3 y 100 caracteres";
    public static readonly WRONG_PHASE = "El nombre de la fase debe estar entre 3 y 100 caracteres";
    public static readonly WRONG_PERCENTAGE = "El porcentaje de los recursos a utilizar debe estar entre 1 y 100";
}